/* Container */
.menuContainer {
  min-height: 100vh;
  background-color: #F7F9FC;
}

/* Header */
.header {
  background-color: #635BFF;
  color: white;
  padding: 40px 0 20px;
  margin-bottom: 20px;
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

.headerContent {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.logoContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.restaurantName {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: white;
}

.restaurantDescription {
  font-size: 16px;
  opacity: 0.8;
  margin-top: 8px;
  margin-bottom: 10px;
}

.tableInfo {
  display: inline-flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 5px;
}

.backButton {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.backButton:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Menu Content */
.menuContent {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Categories Nav - Enhanced version */
.categoriesNav {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  background-color: var(--bg-primary);
  padding: var(--space-3);
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-5);
  box-shadow: var(--shadow);
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  gap: var(--space-2);
}

.categoriesNav::-webkit-scrollbar {
  display: none;
}

/* Improved category buttons */
.categoryButton {
  padding: var(--space-2) var(--space-4);
  border: none;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  border-radius: var(--radius-full);
}

.categoryButton.active {
  color: var(--text-inverted);
  background-color: var(--primary);
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.categoryButton:not(.active):hover {
  background-color: var(--gray-200);
  transform: translateY(-1px);
}

/* Menu Section - Enhanced version */
.menuSection {
  background-color: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
  margin-bottom: var(--space-6);
  box-shadow: var(--shadow);
}

.categoryTitle {
  font-size: 1.25rem;
  color: var(--text-primary);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 2px solid var(--gray-200);
  position: relative;
}

.categoryTitle::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background-color: var(--primary);
}

.noItems {
  text-align: center;
  padding: 20px;
  color: #718096;
  font-style: italic;
}

/* Menu Item - Enhanced version */
.menuItem {
  display: flex;
  justify-content: space-between;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-3);
  background-color: var(--bg-primary);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
}

.menuItem:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.itemInfo {
  flex: 1;
}

.itemName {
  font-weight: 600;
  color: #2d3748;
  font-size: 16px;
  margin: 0 0 4px 0;
}

.itemDescription {
  color: #718096;
  font-size: 14px;
  margin: 0 0 8px 0;
}

.itemPrice {
  font-weight: 600;
  color: #635BFF;
  font-size: 16px;
}

.itemActions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quantityControl {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f7fafc;
  padding: 4px;
  border-radius: 20px;
}

.quantityButton {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background-color: white;
  color: #635BFF;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.quantityButton:hover {
  background-color: #635BFF;
  color: white;
}

.quantity {
  font-weight: 600;
  color: #2d3748;
  min-width: 24px;
  text-align: center;
}

.addToCartButton {
  background-color: #635BFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.addToCartButton:hover {
  background-color: #524ddb;
}

/* Cart Button */
.cartButton {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background-color: #635BFF;
  color: white;
  border: none;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(99, 91, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 24px;
}

.cartButton:hover {
  transform: scale(1.05);
}

.cartCount {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #e53e3e;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
}

/* Loading, Error, Empty States */
.loadingContainer, .errorContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #F7F9FC;
  padding: 0 20px;
  text-align: center;
}

.loadingSpinner {
  width: 40px;
  height: 40px;
  border: 3px solid #edf2f7;
  border-top-color: #635BFF;
  border-radius: 50%;
  margin-bottom: 20px;
  animation: spin 1s linear infinite;
}

.errorContainer h3 {
  color: #e53e3e;
  margin-bottom: 8px;
}

.errorContainer p {
  color: #718096;
  margin-bottom: 20px;
}

.retryButton {
  padding: 10px 20px;
  background-color: #635BFF;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .headerRow {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .backButton {
    margin-left: auto;
  }
  
  .menuItem {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .itemActions {
    width: 100%;
    justify-content: space-between;
    margin-top: 12px;
  }
  
  .itemPrice {
    margin-top: 8px;
  }
}
/* Menu item images */
.menuItemImageContainer {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
}

.menuItemImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.itemContent {
  display: flex;
  flex: 1;
}

/* Update menuItem to support images */
.menuItem {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #eee;
  align-items: center;
}

@media (max-width: 640px) {
  .menuItem {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .itemContent {
    margin-bottom: 12px;
    width: 100%;
  }
  
  .itemActions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
/* Add these new styles for centered logo */
.centeredLogoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px 0;
  width: 100%;
}

.restaurantLogo {
  width: 140px;
  height: 140px;
  object-fit: contain;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 10px;
}

.restaurantName {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: white;
  text-align: center;
}